{
  "version": 1,
  "asset_id": "f8014f84-74cb-4fed-b602-92bc60311f80",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f8014f84-74cb-4fed-b602-92bc60311f80/hiatal-recurrent-redo-2-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f8014f84-74cb-4fed-b602-92bc60311f80/hiatal-recurrent-redo-2-480.webp",
  "original_filename": "hiatal-recurrent-redo-2-480.webp",
  "size": 33416,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:56:22Z"
}
